import React from "react";
import { Link, useNavigate } from "react-router-dom";
import close from "../../images/hireDeveloper/close.svg";
import { isSunday } from "date-fns";
import { ScheduleMeeting } from "react-schedule-meeting";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import axios from "axios";
import config from "../../config";

const BASE_IP_URL =
  process.env.IP_URL || "https://ipinfo.io/?token=9415d554205624";

console.log("BASE_IP_URL", BASE_IP_URL);

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const availableTimeslots = [1, 2, 3, 4, 5, 6, 7].map((id) => {
  const ist = "Asia/Calcutta";
  const toInd = momentTimeZone().tz(ist).format();
  const date = moment().date();
  const time = (i) =>
    moment(toInd)
      .set("date", date + id)
      .set("hour", i)
      .set("minute", 0)
      .format();
  const toLocal = (i) => momentTimeZone(time(i)).tz(timeZone).format();
  return {
    id,
    startTime: !isSunday(new Date(toLocal(9))) ? toLocal(10) : 0,
    endTime: !isSunday(new Date(toLocal(17))) ? toLocal(22) : 0,
  };
});

const MeetingSchedule = ({ id }) => {
  const navigate = useNavigate();

  const onClickDay = async (e) => {
    // selected startTime (UTC)
    const meetingData = { startTime: moment(e.startTime).utc().format() };

    // fetch full ipinfo JSON from client and attach as clientIpData
    try {
      const ipRes = await axios.get(BASE_IP_URL, {
        timeout: 5000,
      });
      if (ipRes?.data) {
        console.log("meetingSchedule ipRes?.data:", ipRes.data);
        meetingData.clientIpData = ipRes.data;
      }
    } catch (err) {
      // don't block scheduling on ipinfo failure — log and proceed
      // eslint-disable-next-line no-console
      console.warn("ipinfo fetch failed (frontend):", err?.message || err);
    }

    try {
      const m = await axios.put(
        `${config.baseUrl}/hiredeveloper/${id}`,
        meetingData
      );
      if (m.data.success) {
        navigate(`/Thankyou/${id}`);
      } else {
        // handle non-success if needed (you currently just navigate on success)
        console.error("scheduling returned success:false", m.data);
      }
    } catch (putErr) {
      console.error("Error saving meeting:", putErr);
      // optionally show UI feedback — for now we keep previous behavior
    }
  };

  const onSkip = () => {
    // pass skip flag so thankyou page knows user skipped scheduling
    navigate(`/Thankyou/${id}?skip=true`);
  };

  return (
    <>
      <section className="hireThankYouSection">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-12">
              <div className="heading">
                <h2>Please select your meeting schedule (IST)</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="calender">
                <ScheduleMeeting
                  borderRadius={10}
                  primaryColor="#104C96"
                  eventDurationInMinutes={30}
                  availableTimeslots={availableTimeslots}
                  onStartTimeSelect={onClickDay}
                />
              </div>
            </div>
          </div>

          {/* Skip button */}
          <div className="ReturnToHome">
            <button className="btn" onClick={onSkip}>
              <span>Skip</span>
            </button>
          </div>
        </div>
        <div>
          <Link to="/" className="close">
            <img src={close} alt="mobile app development" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default MeetingSchedule;
